/**
 * Anonymous fixture data for the legacy daily schedule replica.
 * This file deliberately contains no source customer, employee, branch, or contract data.
 */
export type DailyScheduleCard = {
  id: string
  column: number
  slot: number
  span: number
  kind: 'shoot' | 'general'
  title: string
  subtitle: string
  note?: string
}

export const legacyDailyScheduleColumns = Array.from({ length: 10 }, (_, index) => ({
  id: `section-${index + 1}`,
  label: index === 9 ? '미지정' : `섹션 ${String(index + 1).padStart(2, '0')}`,
  photographer: `촬영 ${String.fromCharCode(65 + (index % 6))}`,
  director: `연출 ${String.fromCharCode(65 + ((index + 2) % 6))}`,
}))

export const legacyDailyScheduleStats = [
  { label: '오늘 촬영', value: '12', tone: 'default' },
  { label: '완료', value: '3', tone: 'blue' },
  { label: '변경 · 취소', value: '2', tone: 'orange' },
  { label: '방문상담', value: '4', tone: 'green' },
  { label: '중복', value: '1', tone: 'pink' },
]

export const legacyDailyScheduleFilterLabels = [
  '모두', '미완료', '완료', '연기', '취소', '변경', '노쇼', '2주', 'OK',
]

export const legacyDailySchedulePhotoFilterLabels = ['모두', '촬영일정', '일반일정']

export const legacyDailyScheduleCards: DailyScheduleCard[] = [
  { id: 'g-01', column: 0, slot: 0, span: 8, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 'g-02', column: 1, slot: 0, span: 8, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 'g-03', column: 2, slot: 0, span: 8, kind: 'general', title: '내부 일정', subtitle: '일반 일정', note: '메모' },
  { id: 'g-04', column: 4, slot: 0, span: 8, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 'g-05', column: 8, slot: 4, span: 4, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 's-01', column: 0, slot: 8, span: 4, kind: 'shoot', title: 'Mock 고객 001', subtitle: '촬영 일정', note: '테마 A' },
  { id: 's-02', column: 1, slot: 8, span: 4, kind: 'shoot', title: 'Mock 고객 002', subtitle: '촬영 일정', note: '테마 B' },
  { id: 's-03', column: 2, slot: 8, span: 4, kind: 'shoot', title: 'Mock 고객 003', subtitle: '촬영 일정', note: '테마 C' },
  { id: 's-04', column: 3, slot: 8, span: 5, kind: 'shoot', title: 'Mock 고객 004', subtitle: '촬영 일정' },
  { id: 's-05', column: 7, slot: 8, span: 4, kind: 'shoot', title: 'Mock 고객 005', subtitle: '촬영 일정' },
  { id: 'g-06', column: 8, slot: 8, span: 4, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 's-06', column: 1, slot: 12, span: 4, kind: 'shoot', title: 'Mock 고객 006', subtitle: '촬영 일정', note: '테마 A' },
  { id: 's-07', column: 0, slot: 14, span: 3, kind: 'shoot', title: 'Mock 고객 007', subtitle: '촬영 일정' },
  { id: 'g-07', column: 8, slot: 14, span: 4, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 's-08', column: 2, slot: 15, span: 5, kind: 'shoot', title: 'Mock 고객 008', subtitle: '촬영 일정' },
  { id: 's-09', column: 7, slot: 15, span: 5, kind: 'shoot', title: 'Mock 고객 009', subtitle: '촬영 일정' },
  { id: 's-10', column: 0, slot: 17, span: 4, kind: 'shoot', title: 'Mock 고객 010', subtitle: '촬영 일정' },
  { id: 's-11', column: 1, slot: 17, span: 4, kind: 'shoot', title: 'Mock 고객 011', subtitle: '촬영 일정', note: '메모' },
  { id: 's-12', column: 1, slot: 21, span: 4, kind: 'shoot', title: 'Mock 고객 012', subtitle: '촬영 일정' },
  { id: 'g-08', column: 8, slot: 21, span: 4, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 's-13', column: 0, slot: 23, span: 4, kind: 'shoot', title: 'Mock 고객 013', subtitle: '촬영 일정' },
  { id: 'g-09', column: 3, slot: 23, span: 6, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 's-14', column: 7, slot: 23, span: 5, kind: 'shoot', title: 'Mock 고객 014', subtitle: '촬영 일정' },
  { id: 'g-10', column: 0, slot: 27, span: 6, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 's-15', column: 1, slot: 27, span: 4, kind: 'shoot', title: 'Mock 고객 015', subtitle: '촬영 일정' },
  { id: 'g-11', column: 4, slot: 27, span: 6, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 'g-12', column: 8, slot: 27, span: 6, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
  { id: 's-16', column: 2, slot: 36, span: 4, kind: 'shoot', title: 'Mock 고객 016', subtitle: '촬영 일정', note: '테마 B' },
  { id: 's-17', column: 6, slot: 41, span: 5, kind: 'shoot', title: 'Mock 고객 017', subtitle: '촬영 일정' },
  { id: 'g-13', column: 9, slot: 50, span: 4, kind: 'general', title: '내부 일정', subtitle: '일반 일정' },
]

export const legacyDailyScheduleTodayItems = [
  { time: '09:00', label: '촬영 일정 01' },
  { time: '09:00', label: '촬영 일정 02' },
  { time: '10:20', label: '일반 일정 01' },
  { time: '11:10', label: '촬영 일정 03' },
  { time: '12:00', label: '촬영 일정 04' },
  { time: '13:30', label: '일반 일정 02' },
  { time: '15:00', label: '촬영 일정 05' },
  { time: '16:20', label: '촬영 일정 06' },
]

export const legacyDailyScheduleWaitItems = [
  { label: '대기 일정 01', time: '14:00' },
]

export const legacyDailySchedulePrintRows = Array.from({ length: 65 }, (_, index) => ({
  time: `${String(9 + Math.floor(index / 6)).padStart(2, '0')}:${String((index % 6) * 10).padStart(2, '0')}`,
  customer: `고객 ${String(index + 1).padStart(3, '0')}`,
  title: '촬영 일정',
  number: `M${String(index + 1).padStart(3, '0')}`,
  product: '상품',
  birth: '30일',
  photographer: '담당A',
  director: '연출A',
  manager: '상담A',
}))
